import React from 'react'

import { RootChartConfigObject } from '../../../types/shared'
import { NotificationWrapper } from '../../components'
import { ElementStyleDialogWrapper } from '../../modals/element_style'
import { useChartLayoutGlobalModel } from '../chart-settings'
import { ChartLayoutComponent } from './chart_layout_component'

interface ChartLayoutProps {
  config: RootChartConfigObject
  shouldResize?: boolean
  parentElement?: HTMLElement
}

export function ChartLayout({ config, shouldResize }: ChartLayoutProps) {
  return (
    <NotificationWrapper>
      <ElementStyleDialogWrapper>
        <ChartLayoutComponent config={config} shouldResize={shouldResize} />
      </ElementStyleDialogWrapper>
    </NotificationWrapper>
  )
}

export function ChartLayoutWithGlobalState({ config, shouldResize, parentElement }: ChartLayoutProps) {
  const { setChartLayoutModel, getChartLayoutModelConfig, lastGlobalRerender } = useChartLayoutGlobalModel()

  return (
    <NotificationWrapper>
      <ElementStyleDialogWrapper>
        {config && (
          <ChartLayoutComponent
            key={lastGlobalRerender}
            config={getChartLayoutModelConfig({ fallback: config })}
            shouldResize={shouldResize}
            onRegisterChartLayoutModel={setChartLayoutModel}
            parentElement={parentElement}
          />
        )}
      </ElementStyleDialogWrapper>
    </NotificationWrapper>
  )
}
